import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const RadioButtonComponent = ({ children, labelClassName, disabled, ...rest }) => (
  <label className={classNames('main-radio', labelClassName)}>
    <input {...rest} type="radio" className="main-radio__input" disabled={disabled} />

    <span className={`main-radio__icon mr-10 ${disabled ? 'disabled' : ''}`} />

    <span className={`main-radio__text ${disabled ? 'disabled' : ''}`}>
      {children}
    </span>
  </label>
);

RadioButtonComponent.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,

  labelClassName: PropTypes.string,
  disabled: PropTypes.bool
};

RadioButtonComponent.defaultProps = {
  labelClassName: '',
  disabled: false
};

export default RadioButtonComponent;
